<template>
	<OnboardingStep :commit="commit" :next-button="false">
		
		<template #heading>
			<h1 class="onboarding-step-heading">My main goal is to...</h1>
		</template>
		

		<template #default="{ next }">
			<div class="mx-auto" style="max-width:526px">
				<OnboardingChoiceButton @click="getHired(next)">
					<template #heading>Get hired</template>
					by studios for their jobs
				</OnboardingChoiceButton>
				<OnboardingChoiceButton @click="findTalent(next)">
					<template #heading>Find talent</template>
					to support your booked jobs
				</OnboardingChoiceButton>
				<OnboardingChoiceButton @click="getHired(next)">
					<template #heading>Do Both</template>
					get hired and find talent
				</OnboardingChoiceButton>
			</div>
		</template>
	</OnboardingStep>
</template>

<script>
import onboarding from '@/mixins/onboarding';

export default {
	name: 'OnboardingGoal',
	mixins: [onboarding],
	onboardingStep: {
		isApplicable: ({ user }) => !user,
		isCompleted: ({ plan }) => plan,
	},
	methods: {
		commit() {
			this.$gtmDispatchOnboardingStepEvent(1, 'User Goal Selected');
		},
		findTalent(next) {
			this.setPlan('studio');
			this.$gtmDispatchOnboardingOptionEvent(1, 'Find Talent');
			next();
		},
		getHired(next) {
			const { plan } = this;
			if (plan && !plan.canBeHired) {
				this.setPlan(null);
			}
			
			this.$gtmDispatchOnboardingOptionEvent(1, 'Get Hired');
			next();
		},
		setPlan(plan) {
			this.$store.commit('onboarding/setPlan', plan);
		},
	},
	mounted() {
		this.$store.dispatch('subscriptions/getLevels');
	},
};
</script>
